import { typeOf } from '../typeOf';
/**
 * Returns true if the type of value is the same as the provided type
 *
 * @since v2.27.0
 * @category Type
 * @param {*} value - The value to check
 * @param {string} type - The type to check against
 * @returns {boolean}
 * @example
 * is('Hello world', 'string') //=> true
 * is({}, 'object')            //=> true
 * is(null, 'object')          //=> true
 * is(undefined, 'undefined')  //=> true
 * is(25, 'symbol')            //=> false
 * @docgen_example
 * is('Hello world', 'string');
 */
export var is = function (value, type) { return typeOf(value) === type; };
